import { breakpoints } from '@finnairoyj/fcom-ui-styles/index.js';
import { ClientType } from '../types';

export const getClientType = (width: number): ClientType => {
  const laptop = parseInt(breakpoints.laptop, 10);
  const desktop = parseInt(breakpoints.desktop, 10);
  if (width >= desktop) {
    return ClientType.DESKTOP;
  } else if (width >= laptop) {
    return ClientType.LAPTOP;
  }

  return ClientType.MOBILE_TABLET;
};
